import { render, staticRenderFns } from "./resource-tupian.vue?vue&type=template&id=5641529b&scoped=true&"
import script from "./resource-tupian.vue?vue&type=script&lang=ts&"
export * from "./resource-tupian.vue?vue&type=script&lang=ts&"
import style0 from "./resource-tupian.vue?vue&type=style&index=0&id=5641529b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5641529b",
  null
  
)

export default component.exports